import React from 'react';
import PropTypes from 'prop-types';
import { isEqual } from 'lodash';
import { ChromePicker } from 'react-color';
import chroma from 'chroma-js';

import Styles from './styles';

const getColorForComponent = (color, alpha) => {
  const rgbaColor = { a: alpha };
  const rgbArray = chroma(color).rgb();
  [rgbaColor.r, rgbaColor.g, rgbaColor.b] = rgbArray;
  return rgbaColor;
};

class ColorPicker extends React.Component {
  state = {
    displayColorPicker: false,
    stateColor: this.props.color,
    stateAlpha: this.props.alpha
  };

  async componentDidUpdate(prevProps) {
    const { color, alpha } = this.props;
    const { color: prevColor, alpha: prevAlpha } = prevProps;
    if (!isEqual(color, prevColor) || !isEqual(alpha, prevAlpha)) {
      this.updateStateColor({ hex: color, rgb: { a: alpha } });
    }
  }

  handleClick = () => {
    const { isClickable } = this.props;
    if (isClickable) {
      this.setState(prevState => ({ displayColorPicker: !prevState.displayColorPicker }));
    }
  };

  handleClose = () => {
    const { updateColor } = this.props;
    const { stateColor, stateAlpha } = this.state;
    this.setState({ displayColorPicker: false });
    updateColor({ hex: stateColor, rgb: { a: stateAlpha } });
  };

  updateStateColor = rgbaColor =>
    this.setState({ stateColor: rgbaColor.hex, stateAlpha: rgbaColor.rgb.a });

  render() {
    const { isClickable, disableAlpha, isTable } = this.props;
    const { displayColorPicker, stateColor, stateAlpha } = this.state;
    return (
      <>
        <Styles.Swatch onClick={this.handleClick} isClickable={isClickable}>
          <Styles.Color color={stateColor} alpha={stateAlpha} />
        </Styles.Swatch>
        {displayColorPicker && (
          <Styles.PopOver isTable={isTable}>
            <Styles.Cover onClick={this.handleClose} />
            <Styles.ChromaContainer>
              <ChromePicker
                color={getColorForComponent(stateColor, stateAlpha)}
                onChangeComplete={this.updateStateColor}
                disableAlpha={disableAlpha}
              />
            </Styles.ChromaContainer>
          </Styles.PopOver>
        )}
      </>
    );
  }
}

ColorPicker.defaultProps = {
  isClickable: true,
  disableAlpha: false,
  isTable: false,
  updateColor: () => console.error('color can not be updated')
};

ColorPicker.propTypes = {
  isClickable: PropTypes.bool,
  disableAlpha: PropTypes.bool,
  updateColor: PropTypes.func,
  isTable: PropTypes.bool,
  color: PropTypes.string.isRequired,
  alpha: PropTypes.number.isRequired
};

export default ColorPicker;
